import { useEffect, useState } from "react";

export default function TableFilterPopover({
  value,
  onChange,
  onClear,
  placeholder = "Type to search...",
  label = "Search",
}) {
  return (
    <div className="w-[220px]">
      <label className="block text-xs font-medium text-stone-600 mb-1">
        {label}
      </label>

      <div className="flex items-center gap-2">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full h-10 px-3 border border-stone-300 rounded-lg bg-white text-sm focus:outline-none focus:ring-2 focus:ring-stone-300"
        />

        {value ? (
          <button
            type="button"
            onClick={onClear}
            className="h-10 px-3 rounded-lg border border-stone-200 bg-white hover:bg-stone-100 text-sm"
          >
            Clear
          </button>
        ) : null}
      </div>
    </div>
  );
}